const e = "_container_1eg0c_15", n = "_animated_1eg0c_19", t = "_circleContainer_1eg0c_26", c = "_rectangleContainer_1eg0c_31", a = "_centered_1eg0c_35", r = {
  container: e,
  animated: n,
  circleContainer: t,
  rectangleContainer: c,
  centered: a
};
export {
  n as animated,
  a as centered,
  t as circleContainer,
  e as container,
  r as default,
  c as rectangleContainer
};
//# sourceMappingURL=Skeleton.module.css.js.map
